import {
	CONNECTION_OFFLINE,
	CONNECTION_ONLINE,
	WINDOW_GET_FOCUS,
	WINDOW_GET_VISIBILITY,
	WINDOW_LOSE_FOCUS, WINDOW_LOSE_VISIBILITY
} from "../actions/windowFocus";

const initialState = {
	windowIsVisible: document.visibilityState === 'visible',
	windowIsFocused: document.hasFocus(),
	isOnline: navigator.onLine,
};

export default (state = initialState, action) => {
	switch(action.type) {
		case CONNECTION_ONLINE: {
			return {
				...state,
				isOnline: true
			};
		}
		case CONNECTION_OFFLINE: {
			return {
				...state,
				isOnline: false
			};
		}
		case WINDOW_GET_FOCUS: {
			return {
				...state,
				windowIsFocused: true
			};
		}
		case WINDOW_LOSE_FOCUS:
			return {
				...state,
				windowIsFocused: false
			};
		case WINDOW_GET_VISIBILITY: {
			return {
				...state,
				windowIsVisible: true
			};
		}
		case WINDOW_LOSE_VISIBILITY:
			return {
				...state,
				windowIsVisible: false
			};
		default:
			return state;
	}
}